import { render, staticRenderFns } from "./journey.vue?vue&type=template&id=5e9d2adc&scoped=true"
import script from "./journey.vue?vue&type=script&lang=js"
export * from "./journey.vue?vue&type=script&lang=js"
import style0 from "./journey.vue?vue&type=style&index=0&id=5e9d2adc&prod&lang=css"
import style1 from "./journey.vue?vue&type=style&index=1&id=5e9d2adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9d2adc",
  null
  
)

export default component.exports